var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59627 0.750366C5.09212 0.263442 4.4169 -0.00598935 3.71602 0.00010105C3.01515 0.00619145 2.34471 0.287317 1.8491 0.782928C1.35349 1.27854 1.07236 1.94898 1.06627 2.64985C1.06018 3.35073 1.32961 4.02595 1.81654 4.5301L17.2536 19.9672L1.81386 35.4042C1.55856 35.6508 1.35491 35.9457 1.21482 36.2719C1.07473 36.598 1.00099 36.9488 0.997904 37.3037C0.994819 37.6586 1.06245 38.0106 1.19686 38.3391C1.33126 38.6676 1.52975 38.9661 1.78073 39.2171C2.03171 39.4681 2.33017 39.6665 2.65868 39.8009C2.98719 39.9353 3.33918 40.003 3.69411 39.9999C4.04904 39.9968 4.3998 39.9231 4.72593 39.783C5.05206 39.6429 5.34702 39.4392 5.5936 39.1839L21.0333 23.7469L36.4704 39.1839C36.9745 39.6709 37.6497 39.9403 38.3506 39.9342C39.0515 39.9281 39.7219 39.647 40.2175 39.1514C40.7132 38.6558 40.9943 37.9853 41.0004 37.2845C41.0065 36.5836 40.737 35.9083 40.2501 35.4042L24.8131 19.9672L40.2501 4.5301C40.737 4.02595 41.0065 3.35073 41.0004 2.64985C40.9943 1.94898 40.7132 1.27854 40.2175 0.782928C39.7219 0.287317 39.0515 0.00619145 38.3506 0.00010105C37.6497 -0.00598935 36.9745 0.263442 36.4704 0.750366L21.0333 16.1874L5.59627 0.747693V0.750366Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fc2185ab.svg";
export { ForwardRef as ReactComponent };